export function valueAsCents(value: number): number {
    return !isNaN(value) ? Math.trunc(value * 100) : null;
}

export function centsAsDollars(value: number): number {
    return !isNaN(value) ? Math.trunc(value / 100) : null;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/helpers/curency.util.ts